"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GRID_CATEGORY_KEY = 'base';
exports.GRID_COMPONENT_KEY = 'grid';